import React from 'react';
import background from '../../assets/ask-oceans.jpg';
import ReusableAskearth from '../../components/ReusableAskearth/ReusableAskearth';


class AskOceans extends React.Component {
  render () { 
   return(
  <ReusableAskearth             
    
        tag="ASK EARTH"
        description01="Why are the Oceans important?"

        
        background={background}
     />

  );
 }
}   

export default AskOceans;
